export const ASSURANCE_DATA_TYPE_CARD = 'CARD';
export const ASSURANCE_DATA_TYPE_CARDHOLDER = 'CARDHOLDER';
export const ASSURANCE_DATA_TYPE_CONSUMER = 'CONSUMER';
export const ASSURANCE_DATA_TYPE_RELATIONSHIP = 'RELATIONSHIP';
export const ASSURANCE_DATA_TYPE_DEVICE = 'DEVICE';
